import GridComponent from '../../component/grid/GridComponent.component';
import Card from '../../component/card/Card.component';
import Grid from '@material-ui/core/Grid';
import ButtonLink from '../../component/buttton/ButtonLink.component';
import Router from './FindTec.container';
import { Container } from '../../component/container/Container';

export default function FindTec() {

    return (
        <Container margin="0px 0px 40px 0px">
            <GridComponent>
                <ButtonLink title="Mapa" link='/cenco-geo' margin="0px 10px 10px 0px" />
                <ButtonLink title="Profissionais " link='/cenco-geo/profissionais' margin="0px 10px 10px 0px" />
            </GridComponent>

            <Card color="#fbfbfb" padding={'10px 20px'} >
                <Grid item sm={12}>
                    <Router />
                </Grid>
            </Card>
        </Container>
    );
}
